(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-upsell-loader"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-recommendations')) {
    customElements.define(
      'cart-recommendations',
      class CartRecommendations extends HTMLElement {
        connectedCallback() {
          if (this.dataset.loaded === 'true' || !this.dataset.url) return;
          this.dataset.loaded = 'true';
          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const container = document.createElement('div');
              container.innerHTML = text;
              const recommendations = container.querySelector('.cart-upsell');
              if (recommendations) this.replaceChildren(recommendations);
              else this.remove();
            })
            .catch(() => this.remove());
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
